import { IConsolidacaoTableEntity, InformaoAnoMes } from "services/NGT/EffectiveConsolidation"
import { FormatNumber } from "../../Shared/FormatNumber";

export class FormatEffectiveQuantityNumbers {

  static formatarNumero(numero: number) {
    return FormatNumber.formatarNumero(numero);
  }

  static formatarTableEntity(tableData: IConsolidacaoTableEntity) {
    if (tableData) {
      tableData.items.map(
        (item) => this.mapTableDataItem(item.informaoAnoMeses)
      )
    }
  }
  static formatarSubItensTableData(tableData: IConsolidacaoTableEntity) {
    if (tableData) {
      tableData.items.map(
        (item) =>
          (item.unidadeGestoraInfo.map((subitem) => this.mapTableDataItem(subitem.informaoAnoMeses)))
      )
    }
  }

  static mapTableDataItem(infoList: InformaoAnoMes[]) {
    infoList.map((info) => {
      return info.info.qtdTotalEfetivo = this.formatarNumero(info.info.qtdTotalEfetivo) as unknown as number
    })
    return infoList;
  }
}
